import React, { useMemo, useState } from 'react';
import { FilterProps } from '../../../../common/filter.util';
import { AssetTransactionStatusFilter } from '../AssetTransactionStatusFilter';
import { Divider, Grid } from '@mui/material';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../../../types/translation/Translator';
import { VentoryColor } from '../../../../../../util/color.util';
import { DeleteIcon } from '../../../../../../icons/Delete/DeleteIcon';
import MultiSelectionList from '../../../../../common/MultiSelectionList';
import SearchBar from '../../../../../common/SearchBar';
import { AssetTransactionUtil } from '../../../../../../../types/asset_transaction/assetTransaction.util';
import { itemsContainText } from '../../../../../../../util/string.util';

interface AssetTransactionStatusFilterContentProps {
  filter: AssetTransactionStatusFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function AssetTransactionStatusFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: AssetTransactionStatusFilterContentProps) {
  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    return new Set(
      [...Object.values(AssetTransactionUtil.DetailedStatus)].filter(s =>
        itemsContainText(query, [translate({ key: s })]),
      ),
    );
  }, [query, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.assetTransactionStatus = selected;
    if (!filterProps.assetTransactionStatus?.size) filterProps.assetTransactionStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.assetTransactionStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container className='h-full'>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>
              {translate({ key: TranslationKey.assetStatus })}
            </p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.assetTransactionStatus}
          values={values}
          onChange={handleChange}
          toText={status => translate({ key: status as TranslationKey })}
        />
      </Grid>
    </Grid>
  );
}
